import * as React from 'react';
import { portalClientApi } from '../../../api/portalClientApi';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { PageHeader } from '../../../designSystem/PageHeader';
import { Card } from '../../../designSystem/Card';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { MessageCard } from '../../../designSystem/Message';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { Small } from '../../../designSystem/typography/Body';
import { EmployeePageWrapper } from '../../_pageWrappers/EmployeePageWrapper';
import { FileLinkListing } from '../../../designSystem/FileLinkListing';
import { PortalSharedDocumentView } from '../../../amorg-common';

export function PortalFileListPage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <PortalFileListPageContent />
        </EmployeePageWrapper>
    );
}

function PortalFileListPageContent(): JSX.Element
{
    const [loading, setLoading] = React.useState(true);
    const [files, setFiles] = React.useState<PortalSharedDocumentView[]>([]);
    const [error, setError] = React.useState('');

    React.useEffect(() =>
    {
        const load = async () =>
        {
            try
            {
                const result = await portalClientApi.getPortalFiles()
                setFiles(result.sort((a, b) => a.publicFileName.localeCompare(b.publicFileName)));
            }
            catch
            {
                setError('Der opstod en fejl ved hentning af delte filer. Prøv igen senere.');
            }
            finally
            {
                setLoading(false);
            }
        };

        load();
    }, []);

    return (
        <SingleColumnLayout
            noDivider
            headerContainer={<PageHeader headerText='Delte dokumenter' headerStyle='primary-black' />}
            contentContainer={
                <>
                    <LoadingPageOverlay loading={loading} />

                    {error !== '' &&
                        <MessageCard variant='error'>{error}</MessageCard>
                    }

                    {!loading && error === '' && files.length === 0 &&
                        <Card variant='outlined'>
                            <Small>Der er ikke delt nogen dokumenter</Small>
                        </Card>
                    }

                    {!loading && error === '' && files.length > 0 &&
                        <Card variant='outlined'>
                            <Flex flexDirection='column' gap={12}>
                                {files.map(file => (
                                    <Flex key={file.privateFileName}>
                                        <FileLinkListing
                                            publicFileName={file.publicFileName}
                                            privateFileName={file.privateFileName}
                                            size={file.sizeBytes}
                                            note={file.note}
                                            employeePortalLink
                                        />
                                    </Flex>
                                ))}
                            </Flex>
                        </Card>
                    }
                </>
            }
        />
    );
}